import './toast-region.js';

function getRegion() {
    let region = document.body.querySelector('toast-region');
    if (!region) {
        region = document.createElement('toast-region');
        document.body.append(region);
    }
    return region;
}
function showToast(options) {
    return getRegion().show(options);
}
function announce(text) {
    getRegion().announce(text);
}

export { announce, showToast };
